/**
 * Where a visitor reaches the Fenzit team. One place, so the header, footer and
 * pages never disagree. The tel link uses the number in E.164 form.
 */
export const SALES_PHONE_DISPLAY = "+91 92792 30451";
export const SALES_PHONE_HREF = "tel:+919279230451";
export const CONTACT_EMAIL = "hello@fenzit.com";

/** The company LinkedIn page. Null until the owner gives the address; until then the footer shows the icon as "coming soon", not as a link. */
export const LINKEDIN_URL: string | null = null;
